import { HttpClient, HttpParams } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AuthenticationService } from "../auth/authentication.service";

@Injectable({
  providedIn: "root",
})
export class GlobalRequisitionService {
  private ENDPOINT_REQUISITION = "/requisitions";
  public refreshRequisitionList$: EventEmitter<any>;

  constructor(
    private http: HttpClient,
    private auth: AuthenticationService,
    private router: Router
  ) {
    this.refreshRequisitionList$ = new EventEmitter();
  }

  //**================================== Requisition =========================*/
  public getAllRequisition(filter: any, searchValue: any, parameters: any) {
    let params = new HttpParams();

    if (filter?.status !== "" && filter?.status != null) {
      params = params.set("status", filter.status);
    }
    if (filter?.fromDate) {
      params = params.set("fromDate", filter.fromDate);
    }
    if (filter?.toDate) {
      params = params.set("toDate", filter.toDate);
    }
    if (searchValue) {
      params = params.set("search", searchValue);
    }
    if (parameters) {
      params = params
        .set("startFrom", parameters.startRow)
        .set("perPage", "25")
        .set("columnName", parameters.sortModel?.[0]?.colId ?? "");
      // NOTE: original code had no sortOrder; keep as-is unless your API needs it
    }

    return this.http
      .get(environment.base_url + this.ENDPOINT_REQUISITION, {
        observe: "response",
        params,
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }

  public deleteRequisition(id: any) {
    return this.http
      .delete(
        environment.base_url + this.ENDPOINT_REQUISITION + "/" + id,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit("Deleted Requisition");
          return resp;
        }),
        catchError((error) => throwError(() => error))
      );
  }

  /************************************************ Requisition statuses ************************************************************************/
  public getStatuses() {
    return this.http
      .get(environment.base_url + this.ENDPOINT_REQUISITION + "/status", {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }

  /************************************************ Requisition by id ************************************************************************/
  public getRequisitionById(id: any) {
    return this.http
      .get(environment.base_url + this.ENDPOINT_REQUISITION + "/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }

  //************************************************ Requisition Save ************************************************************************/
  public saveRequisition(data: any) {
    return this.http
      .post(environment.base_url + this.ENDPOINT_REQUISITION, data, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit("Saved Requisition");
          return resp;
        }),
        catchError((error) => throwError(() => error))
      );
  }

  //************************************************ Requisition Update ************************************************************************/
  public updateRequisition(data: any) {
    return this.http
      .put(environment.base_url + this.ENDPOINT_REQUISITION, data, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit("Updated Requisition");
          return resp;
        }),
        catchError((error) => throwError(() => error))
      );
  }

  //************************************************ Requisition Approve ************************************************************************/
  public approveRequisition(data: any) {
    return this.http
      .put(
        environment.base_url +
          this.ENDPOINT_REQUISITION +
          "/approve/" +
          data.id,
        data,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit("Approved Requisition");
          return resp;
        }),
        catchError((error) => throwError(() => error))
      );
  }

  //************************************************ Requisition Reject ************************************************************************/
  public rejectRequisition(data: any) {
    return this.http
      .put(
        environment.base_url +
          this.ENDPOINT_REQUISITION +
          "/reject/" +
          data.id,
        data,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit("Rejected Requisition");
          return resp;
        }),
        catchError((error) => throwError(() => error))
      );
  }

  //************************************************ Requisition Cancel ************************************************************************/
  public cancelRequisition(data: any) {
    return this.http
      .put(
        environment.base_url +
          this.ENDPOINT_REQUISITION +
          "/cancel/" +
          data.id,
        data,
        { observe: "response" }
      )
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit("Cancelled Requisition");
          return resp;
        }),
        catchError((error) => throwError(() => error))
      );
  }

  //************************************************ Requisition Approve setup ************************************************************************/
  public RequisitionApproveSetup() {
    return this.http
      .get(environment.base_url + "/requisition-approvals", {
        observe: "response",
      })
      .pipe(
        map((resp: any) => resp),
        catchError((error) => throwError(() => error))
      );
  }

  //************************************************ setup=> save Requisition Approve ************************************************************************/
  public saveRequisitionApproveSetup(data: any) {
    return this.http
      .post(environment.base_url + "/requisition-approvals", data, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit("Saved Requisition Approve Setup");
          return resp;
        }),
        catchError((error) => throwError(() => error))
      );
  }

  //************************************************ setup => delete Requisition Approve  ************************************************************************/
  public deleteRequisitionApproveSetup(id: any) {
    return this.http
      .delete(environment.base_url + "/requisition-approvals/" + id, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit("Deleted Requisition Approve Setup");
          return resp;
        }),
        catchError((error) => throwError(() => error))
      );
  }

  /************************************************ Consignment => update status  ************************************************************************/
  public updateRequisitionStatus(data: any, url: any) {
    return this.http
      .put(environment.base_url + "/" + url, data, { observe: "response" })
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit("Updated Requisition Status");
          return resp;
        }),
        catchError((error) => throwError(() => error))
      );
  }

  public updateRequisitionTransfer(id: any, type: any) {
    let params = new HttpParams().set("type", type);

    return this.http
      .post(
        environment.base_url + "/requisitions/transfer-validate/" + id,
        null,
        { observe: "response", params }
      )
      .pipe(
        map((resp: any) => {
          this.refreshRequisitionList$.emit("Updated Requisition Transfer");
          return resp;
        }),
        catchError((error) => throwError(() => error))
      );
  }
}
